var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex" },
    [
      _c(
        "v-btn",
        {
          attrs: { color: "primary", dark: "", outlined: "" },
          on: { click: _vm.onPay },
        },
        [_vm._v(_vm._s(_vm.btn))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }